import {createSlice} from '@reduxjs/toolkit'
import {IHomePageSupportingAppLink} from 'models/CMS'

interface IProps {
 status: string
 data: IHomePageSupportingAppLink[] | null
}

const initialState: IProps = {
 status: 'idle',
 data: null,
}

const supportingAppLinkReducerSlice = createSlice({
 name: 'supportingAppLinkReducer',
 initialState,
 reducers: {
  setSupportingAppLinkData: (
   supportingAppLinkReducer,
   data
  ) => {
   supportingAppLinkReducer.status = 'Success'
   supportingAppLinkReducer.data = data.payload
  },
 },
})

export const {setSupportingAppLinkData} =
 supportingAppLinkReducerSlice.actions
export default supportingAppLinkReducerSlice.reducer
